import Vue from "vue";
import App from "./App.vue";
import Keycloak from "keycloak-js";
import axios from "axios";
import router from "./router";

Vue.config.productionTip = false;

const tokenInterceptor = () => {
  axios.interceptors.request.use(
    (config) => {
      config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

const keycloak = new Keycloak({
  realm: process.env.VUE_APP_KC_REALM,
  url: process.env.VUE_APP_KC_URL,
  clientId: process.env.VUE_APP_KC_CLIENT_ID,
});

Vue.prototype.$keycloak = keycloak;

keycloak
  .init({ onLoad: "login-required", checkLoginIframe: false })
  .then(() => {
    tokenInterceptor();
    new Vue({
      router,
      render: (h) => h(App),
    }).$mount("#app");

    setInterval(() => {
      keycloak.updateToken(30).catch(() => keycloak.login());
    }, 10000);
  });
